import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const AttributeLayout = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
  Split: 'split',
} as const;

export type AttributeLayoutType =
  (typeof AttributeLayout)[keyof typeof AttributeLayout];

export const AttributeEmphasis = {
  Default: 'default',
  Middle: 'middle',
  Prominent: 'prominent',
} as const;

export type AttributeEmphasisType =
  (typeof AttributeEmphasis)[keyof typeof AttributeEmphasis];

export const AttributeTone = {
  Neutral: 'neutral',
  Success: 'success',
  Muted: 'muted',
} as const;

export type AttributeToneType =
  (typeof AttributeTone)[keyof typeof AttributeTone];

export const AttributeAlign = {
  Center: 'center',
  Start: 'start',
} as const;

export type AttributeAlignType =
  (typeof AttributeAlign)[keyof typeof AttributeAlign];

/** @deprecated Use `AttributeEmphasis`. */
export const AttributeVariant = AttributeEmphasis;

/** @deprecated Use `AttributeEmphasisType`. */
export type AttributeVariantType = AttributeEmphasisType;

export type AttributeProps = {
  label: string;
  data?: string;
  detail?: string;
  layout?: AttributeLayoutType;
  emphasis?: AttributeEmphasisType;
  tone?: AttributeToneType;
  align?: AttributeAlignType;
  icon?: TUNDR_ICONS;
  info?: string;
  testId?: string;
  /** @deprecated Use `layout="horizontal"`. */
  horizontal?: boolean;
  /** @deprecated Use `emphasis`. */
  variant?: AttributeEmphasisType;
};

export type AttributeSlots = {
  default?: () => unknown;
  label?: () => unknown;
  action?: () => unknown;
};
